import { ReactNode } from 'react'
import { Route } from 'react-router-dom'
import PageWrapper from '../components/layout/PageWrapper'
import appRoutes from './appRoutes'
import { RouteType } from './config'
import RenderOnRole from '../components/auth/RenderOnRole'

const generateRoute = (routes: RouteType[]): ReactNode => {
  return routes.map((route, index) => {
    return route.index ? (
      <Route
        index
        path={route.path}
        element={
        <RenderOnRole roles={route.roles ?? []}>
        <PageWrapper state={route.state}>{route.element}</PageWrapper>
        </RenderOnRole>}
        key={index}
      />
    ) : (
      <Route
        path={route.path}
        element={
          <RenderOnRole roles={route.roles ?? []}>
          <PageWrapper state={route.child ? undefined : route.state}>{route.element}</PageWrapper>
          </RenderOnRole>
        }
        key={index}
      >
        {route.child && generateRoute(route.child)}
      </Route>
    )
  })
}

export const routes: ReactNode = generateRoute(appRoutes)
